import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { EssayGenreScoreViewModel, GenreScoreViewModel } from "./performanceReportApiSlice";

export function GenreScoreTable(props: {
	className: string;
	scores: EssayGenreScoreViewModel[];
	averages: GenreScoreViewModel;
}) {
	const hasData = props.scores && props.scores.length > 0;

	const dateTimeTemplate = (rowData: EssayGenreScoreViewModel) => {
		return (
			<Link className="link" to={scoreReportEssayLink(rowData.essayId)}>
				{localeShortDateTime(rowData.date)}
			</Link>
		);
	};

	const argumentativeTemplate = (rowData: EssayGenreScoreViewModel) => {
		return formatNumber(rowData.argumentativeScore);
	};

	const informativeTemplate = (rowData: EssayGenreScoreViewModel) => {
		return formatNumber(rowData.informativeScore);
	};

	const narrativeTemplate = (rowData: EssayGenreScoreViewModel) => {
		return formatNumber(rowData.narrativeScore);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column
					footer="Overall Average"
					footerClassName="font-medium !text-right"
					colSpan={2}
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.argumentativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.informativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.narrativeScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.averageScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.scores}
			dataKey="essayId"
			loading={props.scores == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column header="Date" body={dateTimeTemplate} sortable sortField="date"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Argumentative" body={argumentativeTemplate}></Column>
			<Column header="Informative/Explanatory" body={informativeTemplate}></Column>
			<Column header="Narrative" body={narrativeTemplate}></Column>
			<Column header="Average" field="averageScore"></Column>
		</DataTable>
	);
}
